/**
 * Helpers for Shipping Solr enrichment paths (runSearch).
 */

export function isShippingOrderSearchPath(pathname: string): boolean {
  if (!pathname) return false
  const pathOnly = pathname.split('?')[0].replace(/\/+$/, '')
  // Match any path under the shipping app — `/shipping`, `/shipping/orders`,
  // `/shipping/shipments`, `/shipping/settings`, and nested workflow routes
  // (e.g. `/shipping/orders/:ids/label/new`) — with an optional prefix such as
  // the mimic path. Segment matching avoids false positives on unrelated paths.
  return pathOnly.split('/').filter(Boolean).includes('shipping')
}

/** Account filter merchant_id from search params, else first row's merchant_id (Solr may be array). */
export function resolveMerchantIdForShippingRisk(params: { merchant_id?: unknown }, orders: any[]): string {
  const fromParams =
    params?.merchant_id != null && String(params.merchant_id).trim() !== '' ? String(params.merchant_id).trim() : ''
  if (fromParams) return fromParams
  const raw = orders[0]?.merchant_id
  if (raw == null || raw === '') return ''
  return Array.isArray(raw) ? String(raw[0] ?? '') : String(raw)
}

/** Solr/unified order id fallback chain used for order-level risk signal API lookups. */
export function resolveOrderSolrId(order: {
  id?: unknown
  uniqueKey?: unknown
  order_id?: unknown
}): string {
  const raw = order?.id ?? order?.uniqueKey ?? order?.order_id
  return raw != null && raw !== '' ? String(raw) : ''
}
